import { useEffect } from "react";
import { useNavigate, useRouteError } from "react-router-dom";

export default function RouteErrorModal() {
  const error = useRouteError();
  const navigate = useNavigate();

  useEffect(() => {
    if (error?.status === 401) {
      localStorage.clear();
    }
  }, [error]);

  return (
    <div className="error-modal-backdrop">
      <div className="error-modal">
        <h4>Session Expired</h4>
        <p>Please login again.</p>
        <button onClick={() => navigate("/", { replace: true })}>
          Go to Login
        </button>
      </div>
    </div>
  );
}
